import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import { StoreContext } from './context/StoreContext';
import VendorConflictModal from './components/VendorConflictModal';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import RestaurantDetail from './components/RestaurantDetail';
import SearchResults from './pages/SearchResults';
import GroceryStoreDetail from './components/GroceryStoreDetail';
import Restaurants from './pages/Restaurants';
import Groceries from './pages/Groceries';
import CloudKitchens from './pages/CloudKitchens';
import CloudKitchenDetail from './components/CloudKitchenDetail';
import Cart from './pages/Cart/Cart';
import Checkout from './pages/Checkout/Checkout';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';
import ProtectedCheckoutRoute from './components/ProtectedCheckoutRoute';
import OrderConfirmation from './pages/OrderConfirmation';
import Orders from './pages/Orders';
import TrackOrder from './pages/TrackOrder';
import Profile from './pages/Profile';
import CheckOrder from './pages/CheckOrder';
import GoogleCallback from './components/GoogleCallback';
import CompleteProfile from './pages/CompleteProfile';
import PrivacyPolicy from './pages/PrivacyPolicy';

// adding this comment to check proper working of project after building in aws linux server

function App() {
  // Get the correct state and functions from the context
  const {
    showVendorConflictModal,
    setShowVendorConflictModal,
    conflictingVendorName,
    pendingAddItem,
    addItemToCart
  } = useContext(StoreContext);

  // Handler for confirming vendor change
  const handleConfirmConflict = async () => {
    if (pendingAddItem) {
      await addItemToCart(pendingAddItem, true); // force=true
    }
    setShowVendorConflictModal(false);
  };

  // Handler for canceling vendor change
  const handleCancelConflict = () => {
    setShowVendorConflictModal(false);
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
      <VendorConflictModal
        show={showVendorConflictModal}
        onConfirm={handleConfirmConflict}
        onCancel={handleCancelConflict}
        conflictingVendorName={conflictingVendorName}
      />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/google/callback" element={<GoogleCallback />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/restaurants" element={<Restaurants />} />
        <Route path="/groceries" element={<Groceries />} />
        <Route path="/cloudkitchens" element={<CloudKitchens />} />
        <Route path="/restaurants/:id" element={<RestaurantDetail />} />
        <Route path="/grocery-stores/:id" element={<GroceryStoreDetail />} />
        <Route path="/cloudkitchens/:id" element={<CloudKitchenDetail />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/order" element={
          <ProtectedCheckoutRoute>
            <Checkout />
          </ProtectedCheckoutRoute>
        } />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/my-orders" element={<Orders />} />
        <Route path="/track-order/:orderId" element={<TrackOrder />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/check-order" element={<CheckOrder />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
